<div style="position: relative">
  <div class="product-preview">
    <app-product-list
      [fixStatusIn]="statusIn"
      [fixPageSize]="4"
      [fixPublished]="true"
      [fixCycle]="cycle"
      [hideFilters]="true"
      [skipQueryParams]="true"
      [scrollOnPageChange]="false"
      [hidePagination]="true"
    >
    </app-product-list>
  </div>
  <div class="prev" (click)="prev()" *ngIf="productList?.hasPreviousPage$ | async">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </div>
  <div class="next" (click)="next()" *ngIf="productList?.hasNextPage$ | async">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
</div>
